import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { logoutAndReset } from '../../actions/action_auth';

interface ParentLogoutButtonProps {
  companyName: string;
}

// Logging out is a single dispatch: logoutAndReset owns the store resets, the
// browser-state cleanup, and restoring the studio name afterwards, so this
// button and the Terms & Conditions cancel link cannot drift apart.
const ParentLogoutButton: FC<ParentLogoutButtonProps> = ({ companyName }) => {
  // logoutAndReset is a thunk, so plain Dispatch<AnyAction> will not take it.
  // The root store has no state type yet, hence `unknown` for that slot.
  const dispatch = useDispatch<ThunkDispatch<unknown, unknown, AnyAction>>();

  return (
    <div
      onClick={() => dispatch(logoutAndReset(companyName))}
      className="logout-button cursor-pointer"
    >
      Logout
    </div>
  );
};

export default ParentLogoutButton;
